export enum TipoMarcadorEnum { GENDER, AGE_RANGE, ANSWER, COUNTRY }

const idsTipoMarcador = new Map<TipoMarcadorEnum, string>();
idsTipoMarcador.set(TipoMarcadorEnum.GENDER, "GENDER");
idsTipoMarcador.set(TipoMarcadorEnum.AGE_RANGE, "AGE_RANGE");
idsTipoMarcador.set(TipoMarcadorEnum.ANSWER, "ANSWER");
idsTipoMarcador.set(TipoMarcadorEnum.COUNTRY, "COUNTRY");

const nombresTipoMarcador = new Map<TipoMarcadorEnum, string>();
nombresTipoMarcador.set(TipoMarcadorEnum.GENDER, "genero");
nombresTipoMarcador.set(TipoMarcadorEnum.AGE_RANGE, "edad");
nombresTipoMarcador.set(TipoMarcadorEnum.COUNTRY, "pais");

export const obtenerIdTipoMarcador: (tipo: TipoMarcadorEnum) => string = tipo => idsTipoMarcador.get(tipo) ?? "";
export const obtenerNombreTipoMarcador: (tipo: TipoMarcadorEnum) => string =
        tipo => nombresTipoMarcador.get(tipo) ?? "";
